export default {
  blok: {
    type: Object,
    default: () => ({}),
  },
};
